module.exports = "/assets/site/images/gter.png?69198aad1230dee0f7a77b4133eae8b1";